import { DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';

import { NpsApi } from './NpsApi';

import type { NpsResponse } from './types';

export class NpsClient implements NpsApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;

  constructor(options: { discoveryApi: DiscoveryApi; fetchApi: FetchApi }) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi;
  }

  async getNPS(): Promise<NpsResponse> {
    try {
      const baseUrl = await this.discoveryApi.getBaseUrl('openfeedback');
      const resp = await this.fetchApi.fetch(`${baseUrl}/nps`);

      if (!resp.ok) {
        let errorMessage = 'Unknown error';
        try {
          const errorData = await resp.json();
          errorMessage = errorData.message || errorMessage;
        } catch {
          const errorText = await resp.text();
          errorMessage = errorText || errorMessage;
        }
        throw new Error(errorMessage);
      }

      return await resp.json();
    } catch (error: any) {
      throw new Error(error.message);
    }
  }
}
